import { trpc } from "../../../trpc"
import { AnalyticsQueryArgs } from "../Analytics"
import { BaseGraph } from "./Base"
import { getSubTime } from "./getSubTime"

const format = (num: number | undefined) => {
  if (typeof num === "undefined") {
    return "0 ms"
  }
  return `${num.toFixed(1)} ms`
}

const formatYTicks = (num: number | undefined) => {
  if (typeof num === "undefined") {
    return "0 ms"
  }
  return `${num.toFixed(0)} ms`
}

const info = (
  <div>
    <div>Ideal value is 1000/framerate.</div>
    <div>50 fps → 20 ms</div>
    <div>30 fps → 33.3 ms</div>
  </div>
)

export const PacketArrivalTimeAvgGraph = (props: AnalyticsQueryArgs) => {
  const { from, to } = props.time
  const subTime = getSubTime(props.time)

  const { data: videoData, isFetching } = trpc.analytics.packetArrivalTimeAvgRange.useQuery(
    { ...props, mediaType: "video" },
    {
      keepPreviousData: true,
    }
  )
  const { data: audioData, isFetching: subIsFetching } = trpc.analytics.packetArrivalTimeAvgRange.useQuery(
    { ...props, mediaType: "audio" },
    {
      keepPreviousData: true,
    }
  )

  const mainData = videoData?.[0]?.points || []
  const subData = audioData?.[0]?.points || []

  return (
    <BaseGraph
      mainData={mainData}
      subData={subData}
      splitValues={[0]}
      title="Average packet arrival delta"
      mainDescription="Video"
      subDescription="Audio"
      info={info}
      time={{ from, to, subFrom: subTime.from, subTo: subTime.to }}
      formatValue={format}
      formatYTicks={formatYTicks}
      isLoading={isFetching || subIsFetching}
      minYScale={5}
    />
  )
}
